import React from 'react';
import { BrowserRouter, Route, Link, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import About from './components/About';
import Friends from './components/Friends';

function App() {
    
    return (
        <div>
            <h1>Lesson 20</h1>
            <BrowserRouter>
                <div>
                    <nav>
                    <ul>
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <Link to="/about">About</Link>
                        </li>
                        <li>
                            <Link to="/friends">Friends</Link>
                        </li>
                    </ul>
                    </nav>

                    {/* A <Switch> looks through its children <Route>s and
                        renders the first one that matches the current URL. */}
                    <Routes>
                        <Route path="/" element={<Home/>} />
                        <Route path="/friends" Component={Friends} />
                        <Route path="/about"  Component={About} />
                    </Routes>
                </div>
            </BrowserRouter>
        </div>
    );
}

export default App;